import { UserRole } from './crm-user';

/** Prefix on every issued key. Mirrors `API_KEY_PREFIX` in @care-portals/models. */
export const API_KEY_PREFIX = 'cpsk_';

export type ApiKeyStatus = 'active' | 'revoked';

/**
 * @description An API key as it can be shown after creation. The secret itself is
 * never part of this shape — only `last4`, enough to tell two keys apart.
 */
export interface IApiKey {
  _id: string;
  organization: string;
  name: string;
  /** Last 4 characters of the secret. Render as `cpsk_…{last4}`. */
  last4: string;
  /** Role the key acts with inside `organization`. */
  role: UserRole;
  status: ApiKeyStatus;
  createdBy?: string;
  createdByEmail?: string;
  expiresAt?: Date;
  lastUsedAt?: Date;
  revokedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface ICreateApiKeyRequest {
  name: string;
  /** Defaults to `admin`. Cannot exceed what the caller's own role grants. */
  role?: UserRole;
  /** ISO date. Omit for a key that never expires. */
  expiresAt?: string | null;
}

/**
 * @description Creation is the only response that carries the plaintext `key`. It is
 * hashed on write and cannot be retrieved again.
 */
export interface ICreateApiKeyResponse {
  apiKey: IApiKey;
  key: string;
}

export interface IUpdateApiKeyRequest {
  name?: string;
  status?: ApiKeyStatus;
  expiresAt?: string | null;
}

export interface IApiKeyListQuery {
  /** Revoked keys are excluded unless this is set. */
  includeRevoked?: boolean;
}
